export default __webpack_public_path__ + "85e32c595a6481550619876a30d337c6.png";